import { render, staticRenderFns } from "./ProofOfPayment.vue?vue&type=template&id=54d7d46d&scoped=true&"
import script from "./ProofOfPayment.vue?vue&type=script&lang=js&"
export * from "./ProofOfPayment.vue?vue&type=script&lang=js&"
import style0 from "./ProofOfPayment.vue?vue&type=style&index=0&id=54d7d46d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d7d46d",
  null
  
)

export default component.exports